import { styled } from '@mui/material';

// Chip de tecla (hint "/" del buscador del sidebar).
const StyledSidebarKbd = styled('kbd')(({ theme }) => ({
  border: `1px solid ${theme.palette.hairline.strong}`,
  borderRadius: '6px',
  color: theme.palette.text.secondary,
  fontFamily: 'inherit',
  fontSize: '0.75rem',
  lineHeight: 1.6,
  padding: '0 7px'
}));

export default StyledSidebarKbd;
